<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


//Auto checked "disponibilidad" en filtros de galería
if($('.sidebarBlock.Disponibilidad').length>0) {
//console.log("Disponibilidad");   
  $('.sidebarBlock.Disponibilidad').hide();
  $('#Filter-Disponibilidad-1').prop('checked',true);
  $('#Filter-Disponibilidad-2').prop('checked',false);

  $('[data-type-price="true"] h3').addClass("is-clicked");
  $('[data-type-price="true"]  .sidebarBlock-contentWrapper').show();
}
if($('.sidebarBlock.Availability').length>0) {//en inglés
//console.log("Availability");   
  $('.sidebarBlock.Availability').hide();
  $('#Filter-Availability-1').prop('checked',true);
  $('#Filter-Availability-2').prop('checked',false);

  $('[data-type-price="true"] h3').addClass("is-clicked");
  $('[data-type-price="true"]  .sidebarBlock-contentWrapper').show();
}


//Desplegar banners en SideBar de colecciones

if($('.sidebarBlock.sidebar-product').length>0){
  
  $('.sidebarBlock.sidebar-product h3').addClass("is-clicked");
  $('.sidebarBlock.sidebar-product .sidebarBlock-contentWrapper').show();
}

if($('.sidebarBlock.sidebar-image').length>0){
  
  $('.sidebarBlock.sidebar-image h3').addClass("is-clicked");
  $('.sidebarBlock.sidebar-image .sidebarBlock-contentWrapper').show();
}
if($('.sidebarBlock.sidebar-custom-text').length>0){
  
  $('.sidebarBlock.sidebar-custom-text h3').addClass("is-clicked");
  $('.sidebarBlock.sidebar-custom-text .sidebarBlock-contentWrapper').show();
}



//En mobile duplicar "completa tu look" para recolocarlo
$(document).ready(function()
{

setTimeout(clon_complementary, 12000);

});

function clon_complementary(){
  if($('.product-details .productView-complementary').length>0 && ($(window).width()<500)) {
   // console.log('window' + $(window).width());
    var complementary=$('.product-details .productView-complementary').parent().html().replace("complementary-product-data","complementary-product-data2").replace("complementary-products-title","halo-block-header text-center block-title--style1");;
    //console.log('window' + complementary);
    $('.product-details .productView-complementary').parent().hide();
  
    $('.product-details').append('<div class="productView-moreItem" style="margin-top:45px;"><div class="container">' + complementary + '</div></div>');
    
  }

  //Ocultar bloque countdown en ficha para maquetar espacios
  if($('.productView-countDown').length==0){
    $('.show_countdown').hide();
  }
}

//En menu mobile cambiar enlace a Castore -> target _blank
$(document).ready(function()
{
//setTimeout(blank_castore(), 12000);

}); 

$(document).on('click','.mobileMenu-toggle',function(){blank_castore()});

function blank_castore(){
  const changeBtn = document.querySelector('#MenuMobileListSection-menu a[href ^= "https://castore.com"]');
   changeBtn.target = '_blank';
}

$(document).ready(function(){
    $('body').on("contextmenu",function(e){e.preventDefault();});

   // $('[href*="#cookies"]').click(function(){Didomi.preferences.show();return false;});
   // $('[href*="#cookies"]').addClass('ot-sdk-show-settings');
    
  
    //$('[title="preferencias_cookies"], [title="preferences_cookies"]').click(function(){Didomi.preferences.show();return false;})

});

//$(document).on('click','[href*="#cookies"]',function(){console.log('Click cookie preferences');Didomi.preferences.show();return false;});

$(document).on('click','[href*="#cookies"]',function(){
 // if(OneTrust.IsAlertBoxClosed() === false){

          var prefpc = document.getElementById("onetrust-pc-sdk");
          var filter = document.getElementsByClassName("onetrust-pc-dark-filter")[0];

          prefpc.style = "display: block !important;animation: onetrust_sidebar 3s linear";
          filter.style = "display: block !important;";
          /* Move it (define the animation) */
  //}
});

$(document).ready(function(){
  
$('form.number-text').on('DOMNodeInserted', function(){
  var current_lang = document.getElementsByTagName('html')[0].getAttribute('lang');
  if(current_lang == 'en'){
  
    var n=$('.players_names label.p-without').text();
    // console.log("Sin personalizar" + n.lastIndexOf("Sin personalizar"));
    if(n.lastIndexOf("Sin personalizar")==0 || n.lastIndexOf("Sin personalizar")==1){
      $('.players_names label.p-without').text('Without Customization');
    }

    var n=$('.players_names label.select-palyer').text();
    // console.log("Jugador" + n.lastIndexOf("Jugador"));
    if(n.lastIndexOf("Jugador")==0 || n.lastIndexOf("Jugador")==1){
      $('.players_names label.select-palyer').text('Player');
    }

    var n=$('.players_names label.custom').text();
    // console.log("Personalizado" + n.lastIndexOf("Personalizado"));
    if(n.lastIndexOf("Personalizado")==0 || n.lastIndexOf("Personalizado")==1){
      $('.players_names label.custom').text('Customized');
    }
    
    var n=$('.number-desc label').text();
    // console.log("tu" + n.lastIndexOf("Tu"));
    if(n.lastIndexOf("Tu")==0 || n.lastIndexOf("Tu")==1){
      $('.number-desc label').text('Your number:');
    }
    var n=$('.name-desc label').text();
    // console.log("tu" + n.lastIndexOf("Tu"));
    if(n.lastIndexOf("Tu")==0 || n.lastIndexOf("Tu")==1){
      $('.name-desc label').text('Your name:');
    }
   
    var n=$('.gender .badge-txt p').text();
    // console.log("Elije" + n.lastIndexOf("Tu"));
    if(n.lastIndexOf("Elije")==0 || n.lastIndexOf("Elije")==1){
      $('.gender .badge-txt p').text('Choose a team:');
    }
  
    var n=$('.gender .badges label.men').text();
    // console.log("Masculino" + n.lastIndexOf("Masculino"));
    if(n.lastIndexOf("Masculino")==0 || n.lastIndexOf("Masculino")==1){
      $('.gender .badges label.men').text('Male');
    }
    var n=$('.gender .badges label.women').text();
    // console.log("Femenino" + n.lastIndexOf("Femenino"));
    if(n.lastIndexOf("Femenino")==0 || n.lastIndexOf("Femenino")==1){
      $('.gender .badges label.women').text('Female');
    }
  
     var n=$('.player-select-option-appends option:selected').text();
    // console.log("Select" + n);
    if(n=="Selecciona jugador"){
      $('.player-select-option-appends option:selected').text('Select a player');
    }
  }
  
  
});

var current_lang = document.getElementsByTagName('html')[0].getAttribute('lang');
  // console.log('Language:' + current_lang);
  if(current_lang == 'en'){
      $('[href^="https://shop.sevillafc.es"]').each(function(){
          var h=$(this).attr('href');
          if(h.lastIndexOf("https://shop.sevillafc.es/en")==-1){
            // console.log(h);
            var h2=h.replace("https://shop.sevillafc.es","https://shop.sevillafc.es/en");
            // console.log(h2);
            $(this).attr({'href':h2});
          }
        
      })
  }
  

}); 



$(document).ready(function(){
   // Extender jQuery para agregar soporte para :containsRegex
  $.expr[':'].containsRegex = function(elem, index, match) {
      var regex = new RegExp(match[3]);
      return regex.test($(elem).text());
  };
  
  // Ocultar elementos <li> que contienen una fecha (el product type de las camisetas con serigrafía)
  $('.facets__list li:containsRegex(\\b\\d{2}/\\d{2}/\\d{4}\\b)').hide();

    $('#CollectionProductGrid').on('DOMNodeInserted', function(){
     $('.facets__list li:containsRegex(\\b\\d{2}/\\d{2}/\\d{4}\\b)').remove();
  });

});